import React from 'react';
import {Map} from 'immutable';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {emptyObject} from '@packages/utilities/fp/utils';
import {UsysUtilityPageConstraint, setDisplayBlock} from './utils';
import {
  USYS_DOM_CLASS_NAMES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {px, percent} from '@packages/systems/core/utils/WebflowCssSubset';

import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

// @ts-expect-error - TS7031 - Binding element 'runtimeEnvironment' implicitly has an 'any' type. | TS7031 - Binding element 'tempState' implicitly has an 'any' type.
const shouldThisComponentBeShown = ({runtimeEnvironment, tempState}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return tempState === 'error';
  }
  return false;
};

const styleDisplayNone = Map({style: Map({display: 'none'})});

const UserFormErrorState = Atom.createRender(
  ({attributes, data, renderChild, classes, generateAttributes, context}) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const errorMessageClasses = classes.push(USYS_DOM_CLASS_NAMES.formError);
    const tempState = context.get('formState');
    const styledAttributes = shouldThisComponentBeShown({
      runtimeEnvironment,
      tempState,
    })
      ? attributes
      : attributes.merge(styleDisplayNone);

    const attributesWithType = styledAttributes.set(
      USYS_DATA_ATTRS.formError,
      'true'
    );
    const props = generateAttributes(attributesWithType, errorMessageClasses);
    const finalProps =
      tempState === 'error'
        ? {
            ...props,
            style: setDisplayBlock(props.style || emptyObject),
          }
        : props;
    return (
      <div {...finalProps}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    page: [UsysUtilityPageConstraint],
  },
  lockedStyles: {
    display: {
      when: true,
      message: "The display setting can't be changed for a form's error state.",
    },
  },
  render: UserFormErrorState,
  style: {
    base: {
      main: {
        noPseudo: {
          position: 'absolute',
          top: percent(100),
          left: percent(0),
          right: percent(0),
          marginLeft: px(20),
          marginRight: px(20),
        },
      },
    },
  },
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Users'), typeName('UserFormErrorStateChildren'))
  ),
});

export default config;
